import { find, every } from 'lodash';

import { Magnitude, findByType, if$ } from 'gear';

import { Point, Process, TextChar,
         CharTransform, CharTransformList } from 'cdl';

import { Tool } from '../view';


export const CharsTransformTool = Tool.extend({ typeName: 'CharsTransformTool',
  type: 'Final',
  toolbarName: 'charsTransformTool',
  initTool( view, text ) {
    const _this = this;
    _this._char = null;
    _this._text = null;

    if( text && _this.canEdit(text) ) {
      _this._text = text;
      return _this.updateText$();
    }
  },
  canEdit( figure ) {
    return figure.isText &&
           figure.canBeProcessedLocally() &&
           every( figure.processes, p => p.outputsText() ) &&
           ! figure.isMultiPart;
  },
  updateText$() {
    const _this = this;
    return _this._text.update$() .then( () => {
    _this._matrix = _this._text.matrix_();
    _this.view.redraw('tools');
    });
  },

  link( view ) {
    view.cursor = 'pointer';
  },

  unlink( view ) {
    view.cursor = 'default';
  },

  _commit$( view, doc ) {
    const text = this._text;
    if( text ) {
      view.selectedFigures = [text];
    }
    return doc.commit$();
  },

  _cancel$( view ) {
    return view.revert$();
  },

  on_pointerdown({ view, event, which, docPoint }) {
    const _this = this;
    const leftClick = which === 1 ;
    if( leftClick ) {
      const point = docPoint;

      const text = _this._text;
      if( text ) {
        const char = _this._char = text.charAtPoint_(point);
        if( char ) {
          event.stopPropagation();
          _this._point = point;
          _this._downPoint = point.clone();
          const matrix = text.matrix_();
          _this._charGrip = matrix.apply( char._grip );
          _this.view.redraw('tools');
          return;
        }
      }

      const figure = event.figure; // [EVENTS] view.figureAtPoint(point);
      if( figure && _this.canEdit(figure) ) {
        event.stopPropagation();
        if$( _this._changed, () => {
          _this._changed = false;
          return view.commit$();
        }) .then( () => {
          _this._text = figure;
          _this.updateText$();
        });
      }
      else {
        _this._point = _this._downPoint = null;
        _this.view.redraw('tools');
      }
    }
  },
  on_pointermove({ event, view }) {
    const char = this._char;
    if( char && this._point ) {
      const text = this._text;
      const pn = this._point = event.docPoint;
      const invMatrix = text.matrix_().inverted();
      const offset = pn.minus(this._downPoint);

      char.placeAt('Grip',invMatrix.apply( this._charGrip.plus(offset) ));

      // Regenerate output figure, we need a helper here.
      // Manually preserve the anchor for the moment
      const anchor = text.outputFigure.anchor;
      const newOutput = text._textLayout.shape();
      newOutput.anchor = anchor;

      text.outputFigure = newOutput;

      text._cache.clear();
      text.invalidateView();

      view.batchRedraw('tools');

      view.preview$();
    }
  },
  on_pointerup() {
    const char = this._char;
    if( char ) {
      this._changed = true;

      const text = this._text,
            textLayout = text._textLayout,
            spaceWidth = textLayout.spaceWidth(),
            invMatrix = this._matrix.inverted(),
            docOffset = this._point .minus( this._downPoint),
            finalPos = invMatrix.apply( this._charGrip .plus( docOffset )),
            offset = finalPos .minus( invMatrix.apply(this._charGrip) );

      const idx = char._idx, lineIdx = char._lineIdx;

      // Update layout transforms, in case other processes call layout.outdate()
      char._charData._transformers.push( new TextChar.PinPlacer('Grip', char._grip.clone() ) );

      // Update text processes
      const processes = text._processes;
      let charsTransform = findByType(processes,Process.CharsTransform);
      if( ! charsTransform ) {
        charsTransform = new Process.CharsTransform();
        processes._push( charsTransform ); // Avoid events, the output is already modified
      }
      let ctl = find( charsTransform._chars, c => c._lineIdx === lineIdx && c._idx === idx );
      if( ! ctl ) {
        ctl = new CharTransformList({ lineIdx: lineIdx, idx: idx });
        charsTransform._chars._push(ctl);
      }
      let to = findByType(ctl._transforms,CharTransform.TangencialOffset);
      if( ! to ) {
        to = new CharTransform.TangencialOffset();
        ctl._transforms._push(to);
      }
      const dirX = char._frame.dir_x;
      const co_h = Point.dotProduct(dirX,offset);
      const co_v = Point.dotProduct(dirX.perpendicular(),offset);
      to._h = new Magnitude(((Magnitude.absoluteMMValueFor(to._h,spaceWidth)+co_h) / spaceWidth * 100), '%');
      to._v = new Magnitude(((Magnitude.absoluteMMValueFor(to._v,spaceWidth)+co_v) / spaceWidth * 100), '%');

      this._point = this._downPoint = null;
    }
  },

  draw({ view, context, transform }) {
    const char = this._char;
    const e = view.viewDeltaToTexture(3);
    context.lineWidth = view.viewDeltaToTexture(1);
    if( char ) {
      context.strokeStyle = "#248e1f";
      const frame = char._frame.transformed(this._matrix).extended(e,e,e,e);
      frame.draw(context,transform);
      context.stroke();
    }
    else if( this._text ) {
      const figure = this._text;
      const figureFrame = figure.frame_().transformed(transform).extended(e,e,e,e);
      context.strokeStyle = "#248e1f";
      figureFrame.draw(context);
      context.stroke();
    }
  }
});

Tool.CharsTransform = CharsTransformTool;



/** WEBPACK FOOTER **
 ** ./src/ui/tool/chars-transform.js
 **/